const carouselItems = [
  {
    id: 1,
    title: '2026上半年网红翻车大盘点',
    desc: '从带货虚假宣传到人设崩塌，盘点今年最轰动的十大网红翻车事件，深度解析背后原因与行业反思。',
    tag: '年度专题',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20dramatic%20warm%20coral%20and%20deep%20burgundy%20gradients%2C%20dark%20atmospheric%20mood%2C%20overlapping%20geometric%20shapes%20suggesting%20collage%20of%20social%20media%20posts%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=carousel-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '51黑料网站与91黑料网站的恩怨史',
    desc: '两大知名吃瓜平台的竞争与合作历程，从内容风格到用户群体的全面对比分析。',
    tag: '深度报道',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20amber%20and%20terracotta%20gradients%2C%20dark%20moody%20atmosphere%2C%20dual%20contrasting%20geometric%20elements%2C%20modern%20magazine-style%20layout%2C%20soft%20glow%20accents%2C%20no%20text&width=800&height=500&seq=carousel-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '娱乐圈代孕产业链深度调查',
    desc: '从某知名女星代孕疑云说开去，揭秘娱乐圈背后灰色产业链的运作模式与利益网络。',
    tag: '调查报道',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20editorial%20composition%20with%20deep%20rose%20and%20rich%20burgundy%20tones%2C%20mysterious%20atmospheric%20mood%2C%20abstract%20overlapping%20geometric%20forms%2C%20soft%20dramatic%20spotlight%2C%20no%20text&width=800&height=500&seq=carousel-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '黑料网站大全：新手上路完全指南',
    desc: '第一次接触吃瓜黑料网站？这份指南帮你快速上手，从信息来源辨别到高效吃瓜技巧全覆盖。',
    tag: '使用指南',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20coral%20and%20soft%20amber%20gradients%2C%20clean%20modern%20aesthetic%2C%20geometric%20guide-like%20elements%2C%20inviting%20atmospheric%20lighting%2C%20no%20text&width=800&height=500&seq=carousel-4-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '综艺选秀二十年黑幕演化史',
    desc: '从超女时代到101系选秀，梳理中国综艺选秀史上那些被曝光的内幕操作与选手维权事件。',
    tag: '历史回顾',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20composition%20with%20warm%20terracotta%20and%20deep%20amber%20gradients%2C%20nostalgic%20yet%20dramatic%20mood%2C%20stage-like%20abstract%20geometric%20elements%2C%20soft%20glowing%20highlights%2C%20no%20text&width=800&height=500&seq=carousel-5-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选深度专题报道，全面了解热点事件来龙去脉
          </p>
        </div>

        <div className="flex flex-nowrap overflow-x-auto gap-5 pb-4 snap-x snap-mandatory">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="flex-none w-[320px] sm:w-[380px] md:w-[440px] snap-start group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300">
                <div className="relative h-56 md:h-64 bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6 bg-background-50">
                  <h3 className="text-lg font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}